import { useCurrentPersona, useOrgContext } from '@/shared/ui/hooks'
import { type NavEntry } from './sidebar-nav'
import { visibleNavEntriesForPersona } from './nav-visibility'

export function useVisibleNavEntries(): { entries: NavEntry[]; isLoading: boolean } {
  const { persona, isLoading } = useCurrentPersona()
  const { orgType, clubFeaturesEnabled } = useOrgContext()
  const clubFeaturesHidden = orgType === 'outfitter' && clubFeaturesEnabled === false
  const entries = visibleNavEntriesForPersona(persona, { clubFeaturesHidden })
  return { entries, isLoading }
}
